"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceUUID = exports.initDeviceUUID = void 0;
var deviceUUID_1 = require("./deviceUUID");
Object.defineProperty(exports, "initDeviceUUID", { enumerable: true, get: function () { return deviceUUID_1.initDeviceUUID; } });
Object.defineProperty(exports, "getDeviceUUID", { enumerable: true, get: function () { return deviceUUID_1.getDeviceUUID; } });
//# sourceMappingURL=index.js.map